<gatewee-users
  [users]="users || []"
  [actions]="userActions"
  [breadcrumb]="breadcrumb"
  [title]="'features.users.title'"
  [titlePath]="'features.users.titlePath'"
  [page]="page"
  [pageSize]="pageSize"
  [total]="users?.length ?? 0"
  (pageChange)="onPageChange($event)"
></gatewee-users>
